import { groupBy } from 'lodash';

const groupByDates = (items, dateKey) => {
  const dates = groupBy(items, dateKey);

  return Object.entries(dates).sort((a, b) => {
    const date1 = new Date(a[0]);
    const date2 = new Date(b[0]);

    return date2 - date1;
  });
};

export default groupByDates;
